import styles from "./PortalReviewRating.module.css";

export function portalRatingLabel(rating: number) {
  return `Hodnocení ${new Intl.NumberFormat("cs", { maximumFractionDigits: 1 }).format(rating)} z 5`;
}

export function PortalReviewStar() {
  return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 2.5 2.9 5.88 6.5.95-4.7 4.58 1.1 6.48L12 17.33l-5.8 3.06 1.1-6.48-4.7-4.58 6.5-.95L12 2.5Z" fill="currentColor" /></svg>;
}

export function PortalReviewRating({ rating, decorative = false }: { rating: number; decorative?: boolean }) {
  return <span className={styles.stars} role={decorative ? undefined : "img"} aria-hidden={decorative || undefined} aria-label={decorative ? undefined : portalRatingLabel(rating)}>
    {[1, 2, 3, 4, 5].map((star) => <span key={star} className={styles.star}>
      <PortalReviewStar />
      <span className={styles.starFill} style={{ clipPath: `inset(0 ${100 - Math.max(0, Math.min(1, rating - star + 1)) * 100}% 0 0)` }}><PortalReviewStar /></span>
    </span>)}
  </span>;
}
